import styled from 'styled-components'

export const ModalPaymentContainer = styled.div`
	#cardPaymentBrick_container {
		max-width: 360px !important;
		min-width: 288px !important;
		width: 100%;

		button[type=submit] {
			font-size: 14px;
		}

		@media(max-width: 440px) {
			min-width: 18rem !important;
			width: 18rem;
		}
	}
`
